<template>
  <div>
    <div :class="[$style.title, 'login-heading']">
    </div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase">
                <strong>Fa&ccedil;a seu login</strong>
              </h4>
              <a-form class="login-form" :form="form" @submit="handleSubmit">
                <a-form-item label="Email">
                  <a-input
                    placeholder="Email"
                    v-decorator="['email', { initialValue: 'seu_email@empresa.com.br', rules: [{ required: true, message: 'Please input your username!' }]}]"
                  >
                    <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25);"/>
                  </a-input>
                </a-form-item>
                <a-form-item label="Senha">
                  <a-input
                    placeholder="Password"
                    type="password"
                    v-decorator="['password', {initialValue: 'cleanui', rules: [{ required: true, message: 'Please input your Password!' }]}]"
                  >
                    <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25);"/>
                  </a-input>
                </a-form-item>
                <div>
                  <a-checkbox>Lembrar-me</a-checkbox>
                  <router-link
                    class="pull-right text-primary utils__link--blue utils__link--underlined"
                    to="/user/forgot"
                  >Esqueceu a senha ?</router-link>
                </div>
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button width-150"
                  >Sign in</a-button>
                  <span class="ml-3 register-link">
                    <a
                      href="javascript: void(0);"
                      class="text-primary utils__link--underlined mr-1"
                    >Registre-se</a>caso voc&#234; n&#227;o tenha
                  </span>
                </div>
                <div class="form-group">
                  <p>Outros servi&ccedil;os de Login</p>
                  <div class="mt-2">
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-facebook"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-google"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-windows"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-twitter"/>
                    </a>
                  </div>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          this.$auth.login(values.email, values.password)
            .then(() => {
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Autorizado',
                description: 'Sua autenticação foi realizada com sucesso!',
              })
            })
            .catch((error) => {
              this.$nprogress.done()
              this.$notification['warning']({
                message: error.code,
                description: error.message,
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
